const state = {
  user: null,
};
const getters = {
  isAuthenticated: state => !!state.user,
  UserLogin: state => state.user,
};

const actions = {
  async LogOut({ commit }) {
    let user = null
    localStorage.token = ''
    commit('LogOut', user)
  },

  async SetUser({ commit }, data) { 
    commit('setUser', data)
  },

};
const mutations = {
  setUser(state, data) {
    state.user = data.user
    //state.menus = data.menus 
  },
  LogOut(state) {
    state.user = null
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
